<template>
  <BaseAutoComplete
    v-model="model"
    :options="labors"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { find } from 'underscore'
import { computed, watch } from 'vue'
// import LaborForm from '@/modules/Catalog/Labor/components/LaborForm.vue'
import LaborService from '@/services/LaborService'
import { useQuery } from '@tanstack/vue-query'
import BaseAutoComplete from './BaseAutoComplete.vue'


const selectedLabor = defineModel({
  type: String,
  default: ''
})

// const labor = ref({
//   name: '',
//   description: '',
//   hourlyRate: ''
// })
const emit = defineEmits(['change'])
const laborSerice = new LaborService()
const { data: labors } = useQuery({
  queryKey: ['labors'],
  queryFn: () => laborSerice.all().then((labors) => labors.map((labor) => ({ label: labor.name, value: labor.id, ...labor })))
})

const model = computed({
  get: () => {
    if (labors.value) {
      return find(labors.value, (labor) => labor.value === selectedLabor.value)
    }
    return null
  },
  set: (value) => {
    selectedLabor.value = value.value
  }
})

watch(model, () => {
  if (model.value) {
    selectedLabor.value = model.value.value
  }
  emit('change', model.value)
})

// const saveLabor = async () => {
//   // const labor = await this.createLabor(this.labor)

//   // close modal

//   // reset labor data
//   labor.value = {
//     name: '',
//     description: '',
//     hourlyRate: ''
//   }
// }
</script>
